import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function DistributionModel({ distributionModel }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     direct_sales: "b",
  //     channel_partnerships: "c",
  //     e_commerce_strategy: "d",
  //     direct_sales_positive_insight: "b",
  //     direct_sales_negative_insight: "b",
  //     direct_sales_recent_development: "b",
  //     channel_partnerships_positive_insight: "c",
  //     channel_partnerships_negative_insight: "c",
  //     channel_partnerships_recent_development: "c",
  //     e_commerce_strategy_positive_insight: "d",
  //     e_commerce_strategy_negative_insight: "d",
  //     e_commerce_strategy_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     direct_sales: "b",
  //     channel_partnerships: "c",
  //     e_commerce_strategy: "d",
  //     direct_sales_positive_insight: "b",
  //     direct_sales_negative_insight: "b",
  //     direct_sales_recent_development: "b",
  //     channel_partnerships_positive_insight: "c",
  //     channel_partnerships_negative_insight: "c",
  //     channel_partnerships_recent_development: "c",
  //     e_commerce_strategy_positive_insight: "d",
  //     e_commerce_strategy_negative_insight: "d",
  //     e_commerce_strategy_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     direct_sales: "b",
  //     channel_partnerships: "c",
  //     e_commerce_strategy: "d",
  //     direct_sales_positive_insight: "b",
  //     direct_sales_negative_insight: "b",
  //     direct_sales_recent_development: "b",
  //     channel_partnerships_positive_insight: "c",
  //     channel_partnerships_negative_insight: "c",
  //     channel_partnerships_recent_development: "c",
  //     e_commerce_strategy_positive_insight: "d",
  //     e_commerce_strategy_negative_insight: "d",
  //     e_commerce_strategy_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(distributionModel);
    setTabData(tableData);
  }, [distributionModel]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "direct_sales", label: "Direct Sales" },
    { key: "channel_partnerships", label: "Channel Partnerships" },
    { key: "ecommerce_strategy", label: "E-Commerce Strategy" },
  ];

  return (
    <InsightTable
      title="Distribution Model"
      subtitle="Overview of direct sales structures, channel partnerships, and digital commerce models used by top healthcare supply competitors."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default DistributionModel;
